<template>
  <transition name="el-zoom-in-top">
    <el-card v-show="show" class="box-card" style="text-align: left;">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>修改工单</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right;" type="primary" @click="show = false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <el-form ref="form" :model="form" label-width="110px" style="width:100%" :rules="rules">
        <el-row>
          <el-col :span="6">
            <el-form-item label="工单号" prop="orderno">
              <el-input v-model="form.orderno" style="width:90%" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="计划生产日期" prop="plan_date">
              <el-date-picker style="width: 90%" v-model="form.plan_date" type="date" value-format="yyyy-MM-dd"
                format="yyyy 年 MM 月 dd 日" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="工单类型" prop="orderno_type">
              <el-select v-model="form.orderno_type" type="text" style="width:90%">
                <el-option v-for="item in orderstatus" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="工厂" prop="factory_code">
              <el-select v-model="form.factory_code" type="text" filterable style="width:90%"
                @change="getworkshoplistsearch(form.factory_code)">
                <el-option v-for="(item, index) in factorylist" :key="index" :label="item.factory_name"
                  :value="item.factory_code">
                  <span style="float: left">{{ item.factory_name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.factory_code }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="车间" prop="workshop_code">
              <el-select v-model="form.workshop_code" type="text" filterable style="width: 90%"
                @change="getworklinelistlistsearch(form.workshop_code)">
                <el-option v-for="(item, index) in workshoplist" :key="(item, index)" :label="item.workshop_name"
                  :value="item.workshop_code">
                  <span style="float: left">{{ item.workshop_name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.workshop_code }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产线" prop="workline_code">
              <el-select v-model="form.workline_code" filterable style="width: 90%">
                <el-option v-for="(item, index) in worklinelist" :key="index" :label="item.workline_name"
                  :value="item.workline_code">
                  <span style="float: left">{{ item.workline_name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.workline_code }}</span>
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item v-show="form.orderno_type == 2" label="委托客户编码" prop="entrust_code">
              <el-input v-model.number="form.entrust_code" disabled style="width:90%" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <!-- 填写具体奖项 -->
        <h4>产品记录</h4>
        <br />
        <el-row>
          <el-col :span="11">
            <el-card shadow="never">
              <el-form ref="productform" :model="productform" label-width="140px" style="width:80%" :rules="rules">
                <el-form-item label="产品" prop="product_code">
                  <el-select v-model="productform.product_code" placeholder="请输入产品名称" style="width:70%"
                    :remote-method="getproductlist" filterable remote :loading="productloading"
                    @change="getprodcutname($event)">
                    <el-option v-for="item in productlist" :key="item.product_code" :label="item.product_name"
                      :value="item.product_code">
                      <span style="float: left">{{ item.product_code }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.product_name }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="批次号" prop="batchno">
                  <el-input v-model="productform.batchno" style="width:70%" />
                </el-form-item>
                <el-form-item label="计划生产数量" prop="product_quantity">
                  <el-input v-model.number="productform.product_quantity" style="width:70%" />
                </el-form-item>
                <el-form-item label="计划生产单位" prop="product_unit">
                  <el-select v-model="productform.product_unit" placeholder="请选择" style="width: 70%" remote>
                    <el-option v-for="item in unitarr" :key="item.product_unit_code" :label="item.product_unit_cn"
                      :value="item.product_unit_code">
                      <span style="float: left">{{ item.product_unit_code }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.product_unit_cn }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div style="text-align: center;">
                <el-button style="margin-top: 12px;" @click="resetForm('productform')">重置</el-button>
                <el-button style="margin-top: 12px;" type="primary" @click="productadd('productform')">生成</el-button>
              </div>
            </el-card>
          </el-col>
          <el-col :span="2" style="text-align:center">
            <el-button size="medium" style="margin-top: 100px;" class="el-icon-d-arrow-right" />
          </el-col>
          <el-col :span="11">
            <el-card shadow="never">
              <el-table :data="tablelist" height="224" stripe style="width: 100%" @cell-click="danghang">
                <el-table-column prop="product_code" label="产品编码" show-overflow-tooltip />
                <el-table-column prop="batchno" label="批次号" show-overflow-tooltip />
                <el-table-column prop="product_quantity" label="计划生产数量" min-width="100" />
                <el-table-column prop="product_unit" label="计划生产单位" min-width="100" />

                <el-table-column prop="address" label="操作" width="80">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-button type="danger" @click.native.prevent="deleteRow(scope.$index, tablelist)">删除</el-button>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
        <div style="text-align: center;">
          <el-button style="margin-top: 12px;" type="primary" @click="submitadd('form')">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>

<script>
import {
  workupdate,
  factorylist,
  worklinelist,
  workshoplist,
} from "@/api/plant";
import { productlist, productunitpagelist } from "@/api/base";
import { type } from "os";
export default {
  props: {
    search: {
      type: Function,
      default: null,
    },

  },
  data() {
    return {
      show: false,
      tablelist: [],
      form: {
        orderno: null,
        batchno: null,
        orderno_type: null,
        factory_code: null,
        workshop_code: null,
        workline_code: null,
        plan_date: null,
        entrust_code: null,
      },
      // 基础数据
      orderstatus: [
        {
          value: 0,
          label: "自有工单",
        },
        {
          value: 1,
          label: "外协工单",
        },
        {
          value: 2,
          label: "委托加工",
        },
      ],
      productloading: false,
      productlist: [], // 产品列表下拉
      factorylist: [],
      workshoplist: [],
      worklinelist: [],
      productform: {
        batchno: null,
        product_unit: null,
        product_code: null,
        product_quantity: null,

      },
      unitarr: [],
      rules: {
        plan_date: [
          { required: true, message: "请选择生产日期", trigger: "blur" },
        ],
        product_unit: [
          { required: true, message: "请选择生产单位", trigger: "blur" },
        ],
        orderno: [
          { required: true, message: "工单号", trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" },
        ],
        batchno: [
          { required: true, message: "批次号", trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" },
        ],
        orderno_type: [
          { required: true, message: "请输入工单类型", trigger: "blur" },
        ],
        factory_code: [
          { required: true, message: "请输入工厂编码", trigger: "blur" },
        ],

        product_code: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
        ],
        product_quantity: [
          { required: true, message: "请输入计划生产数量", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    'form.workline_code': {
      handler(newValue, oldValue) {
        console.log('产线变化 changed:', newValue, 'Old value:', oldValue);
        this.worklinelist.find((data) => {
          if (newValue == data.workline_code) {
            this.form.workline_name = data.workline_name;
          }
        })
        // 在这里可以执行你想要的逻辑操作
      },
      deep: true
    },
    'form.factory_code': {
      handler(newValue, oldValue) {
        console.log('产线变化 changed:', newValue, 'Old value:', oldValue);
        this.factorylist.find((data) => {
          if (newValue == data.factory_code) {
            this.form.factory_name = data.factory_name;
          }
        })
        // 在这里可以执行你想要的逻辑操作
      },
      deep: true
    }
  },
  mounted() {
    productunitpagelist({
      status: 0,
      pageindex: 1,
      pageSize: 99,
    }).then((response) => {
      this.unitarr = response.data.data;
    })
    // 下拉
    this.getproductlist(); // 产品下拉
    this.getfactorylst();
  },
  methods: {
    // 获取产品下拉
    getproductlist(value) {
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then((response) => {
            this.productlist = response.data.data;
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    getfactorylst() {
      factorylist({ pageSize: 10000 }).then((response) => {
        this.factorylist = response.data.data;
      });
    },
    // 车间下拉
    getworkshoplistsearch(value) {
      this.form.workshop_code = "";
      this.form.workline_code = "";
      workshoplist({
        factory_code: this.form.factory_code,
        workorder_status: 0,
        pageSize: 1000,
      }).then((response) => {
        this.workshoplist = response.data.data;
      });
    },
    getworklinelistlistsearch(value) {
      // 产线下拉
      this.form.workline_code = "";
      worklinelist({
        workshop_code: value,
        workorder_status: 0,
        pageSize: 1000,
      }).then((response) => {
        this.worklinelist = response.data.data;
      });
    },
    // 把产品添加到表格
    productadd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.tablelist.length == 1) {
          //   this.$message({
          //     type: "warning",
          //     message: "只能添加一个产品",
          //   });
          //   return
          // }
          let obj = Object.assign({}, this.productform);

          for (let i = 0; i < this.tablelist.length; i++) {
            // 产品不能重复
            if (
              this.tablelist[i].product_code ==
              this.productform.product_code
            ) {
              this.tablelist[
                i
              ].product_quantity += this.productform.product_quantity;
              this.$refs[formName].resetFields();
              return;
            }
          }
          this.tablelist.push(obj);
          this.$refs[formName].resetFields();
        } else {
          return false;
        }
      });
    },
    // 表格行删除
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    danghang(row) {
      console.log(row);
    },
    // 根据产品编码获取名称
    getprodcutname(productCode) {
      this.productform.product_unit = "";
      if (this.productform.product_code.length !== 0) {
        productlist({ productCode: this.productform.product_code }).then(
          (response) => {
            if (response.data.data.length == 0) {
              this.$message({
                type: "warning",
                message: "产品编码不存在！",
              });
            } else {
              this.productform.product_unit =
                response.data.data[0].min_pack_unit;
            }
          }
        );
      }
    },
    // 保存提交
    submitadd(formName) {
      // console.log(this.update)
      this.$refs[formName].validate((valid) => {
        // 基础表单验证
        if (valid) {
          if (this.tablelist.length == 0) {
            this.$message({
              type: "warning",
              message: "请添加产品",
            });
            return
          }
          workupdate({
            id: this.form.id,
            orderno: this.form.orderno,
            batchno: this.form.batchno,
            orderno_type: this.form.orderno_type,
            factory_code: this.form.factory_code,
            workshop_code: this.form.workshop_code,
            workline_code: this.form.workline_code,
            workline_name: this.form.workline_name,
            plan_date: this.form.plan_date,
            workorderProducts: this.tablelist,
          }).then((response) => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "提交成功!",
              });
              this.search();
              this.show = false;
              this.tablelist = [];
              this.resetForm(formName);
            } else {
              this.$message({
                type: "warning",
                message: "提交失败!请检查字段",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="scss" scoped></style>
